import {styled} from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import MuiDrawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import {Avatar, ListItemButton, Menu, MenuItem, Typography} from "@mui/material";
import DashboardIcon from '@mui/icons-material/Dashboard';
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import * as React from "react";
import {useState} from "react";
import HotelIcon from '@mui/icons-material/Hotel';
import WorkIcon from '@mui/icons-material/Work';
import Box from "@mui/material/Box";
import {Link, useNavigate} from "react-router-dom";
import {useAuth} from "../../../utils/FirebaseAuthContext";
import "./dashboardStyle.css"
import NotListedLocationIcon from '@mui/icons-material/NotListedLocation';

const drawerWidth = 240;

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(9)} + 1px)`,
    },
});

export const DrawerHeader = styled('div')(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

export const AppBar = styled(MuiAppBar, {

    shouldForwardProp: (prop) => prop !== 'open',
})(({theme, open}) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),

}));

export const Drawer = styled(MuiDrawer, {shouldForwardProp: (prop) => prop !== 'open'})(
    ({theme, open}) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);

function DashboardAvatar() {
    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const auth = useAuth();
    const navigate = useNavigate();
    const handleSignOut = () => {
        handleClose();
        auth.signOut()
            .then(() => {
                navigate("/login");
            });
    }

    return (
        <div>
            <div className={"appbar-toolbar-right-container"}>
                <Avatar id="basic-button"
                        aria-controls="basic-menu"
                        aria-haspopup="true"
                        aria-expanded={openMenu ? 'true' : undefined}
                        onClick={handleClick}
                />

                {/*<Avatar className={"appbar-settings"}><SettingsIcon /></Avatar>*/}
            </div>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={handleClose}>Môj účet</MenuItem>
                <MenuItem onClick={handleSignOut}>Odhlásiť sa</MenuItem>
            </Menu>
        </div>
    );
}


export function DashboardMenu() {
    const [open, setOpen] = useState(false);


    const handleToggle = () => {
        setOpen(!open);
    };
    return (
        <div>
            <CssBaseline/>
            <AppBar position="fixed" open={open}>
                <Toolbar className={"appbar-toolbar"}>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleToggle}
                        edge="start"
                        sx={{
                            marginRight: '36px'
                        }}
                    >
                        <MenuIcon/>
                    </IconButton>

                    <Typography variant="h6" component={Link} to={"/dashboard"} sx={{
                        flexGrow: 1,
                        color: "white",
                        textDecoration: "none",
                    }}>
                        Admin
                    </Typography>

                    <DashboardAvatar/>

                </Toolbar>
            </AppBar>
            <Drawer variant="permanent" open={open}>
                <DrawerHeader/>
                <Divider/>
                <List>
                    <ListItemButton component={Link} to="/dashboard">
                        <ListItemIcon>
                            <DashboardIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Nástenka" />
                    </ListItemButton>

                    <ListItemButton component={Link} to="/jobs">
                        <ListItemIcon>
                            <WorkIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Pracovné ponuky" />
                    </ListItemButton>

                    <ListItemButton component={Link} to="/shelters">
                        <ListItemIcon>
                            <HotelIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Nocľahárne" />
                    </ListItemButton>

                    <ListItemButton component={Link} to="/material-helps">
                        <ListItemIcon>
                            <NotListedLocationIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Materiálna pomoc"/>
                    </ListItemButton>

                </List>
            </Drawer>
        </div>
    );
}

export function DashboardMenuContainer(content) {
    return (
        <Box sx={{display: 'flex'}}>
            <DashboardMenu/>
            <Box component="main" sx={{flexGrow: 1, p: 3}}>
                <DrawerHeader/>
                {content}
            </Box>
        </Box>
    );
}



